import * as React from 'react';
import {loginForm} from 'login/TwoFactorLogin/login';
import {useState} from 'react';
import {unFlattenForm} from 'utils';
import {doSignin, verifyOtp} from 'login/TwoFactorLogin/api';
import {setAuthParameters, setTwoFactorAuth} from "login/actions";
import { setAuthentication } from 'service';
import {IReduxState} from "reducers";
import {IAuth} from "StateInterface";
import {connect} from "react-redux";
import TwoFactorLogin from 'login/TwoFactorLogin';
import {imageBaseUrl} from 'config';
import {IForm} from 'login/TwoFactorLogin';
import {Loading} from "web-com";

interface IConnectProps {
  dispatch?: (action: any) => void;
  auth: IAuth;
  query: any;
  router: any;
}

const TwoFactorAuth = (props: IConnectProps) => {
  const getLoginForm = () => {
    const queryParams = location.hash.split("?");
    const pan = new URLSearchParams(queryParams[1]).get("pan");
    const mobile = new URLSearchParams(queryParams[1]).get("mobile");
    if (queryParams.length > 1) {
      return {
        ...loginForm,
        fields: [{
          ...loginForm.fields[0],
          fields: [
            {
              ...loginForm.fields[0].fields[0],
              value: pan ? pan.toUpperCase() : "",
            },
            {
              ...loginForm.fields[0].fields[1],
              value: mobile ? mobile : "",
            }
          ],
        }],
      }
    } else {
      return loginForm;
    }
  }
  const [login, updateLogin] = useState<IForm>(getLoginForm());
  const [error, setError] = useState<string>(null);
  const [isLoading, setIsLoading] = useState(false);
  const LOGO = `${imageBaseUrl}/img/logo/sl_new_logo1.png`;
  const MESSAGE = 'SignIn to your MyShubhLife account';
  const onFormChange = (index: number, value: string | number | string[] | boolean, formindex: number, fieldname: string) => {
    updateLogin(prevState => ({...prevState,
    fields: [...prevState.fields.slice(0, formindex), {...prevState.fields[formindex],
    fields: [ ...prevState.fields[formindex].fields.slice(0, index), {...prevState.fields[formindex].fields[index],
    [fieldname]: index === 0 && fieldname === 'value' ? value.toString().toUpperCase() : value},
    ...prevState.fields[formindex].fields.slice(index+1)]}, ...prevState.fields.slice(formindex+1)]}));
  };

  const onFormSubmit = () => {
    const signin = unFlattenForm(login.fields)[0]['login'];
    if (login.fields[0]['fields'].length === 2) {
      generateOtp(signin['pan'], signin['mobile'], 0, 2);
    } else {
      const signinDetails = {
        pan: signin['pan'],
        mobile: Number(signin['mobile']),
        otp: Number(signin['otp'].join('')),
      }
      signIn(signinDetails);
    }
  };

  const generateOtp = async (pan: string, mobile: number, formindex: number, index: number) => {
    setIsLoading(true);
    try {
      const res = await doSignin(pan, mobile);
      if (res.data.message === 'OTP Generated') {
        updateLogin(prevState => ({...prevState,
          buttonlabel: 'Sign In',
          fields: [...prevState.fields.slice(0, formindex), {...prevState.fields[formindex],
          fields: [...prevState.fields[formindex].fields.slice(0, index), {
          identifier: 'login:otp',
          type: 'otp',
          otpLength: 6,
          otpType: 'number',
          otp: []}, ...prevState.fields[formindex].fields.slice(index+1)]}, ...prevState.fields.slice(formindex+1)]}))
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message === "User not found"
        ? "We couldn't find your combination of pan and mobile in our existing records. Visit MyShubhLife app to start your loan application"
        : err.response?.data?.message;
      setError(errorMsg || "Something went wrong");
    }
    setIsLoading(false);
  };

  const signIn = async (signinDetails) => {
    setIsLoading(true);
    try {
      const res = await verifyOtp(signinDetails);
      if (res.data.token) {
        sessionStorage.setItem("accessToken", res.data.token);
        sessionStorage.setItem("userId", res.data.userId);
        setAuthentication(res.data.token);
        props.dispatch(setAuthParameters({...props.query, accessToken: res.data.token, userId: res.data.userId}));
        props.dispatch(setTwoFactorAuth({'existing': true, 'roles': res.data.roles, 'userId': res.data.userId}));
      }
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Loading active={isLoading} />
      <TwoFactorLogin
        logo={LOGO}
        message={MESSAGE}
        form={login}
        onFormChange={onFormChange}
        onFormSubmit={onFormSubmit}
        error={error || props.router?.location?.state?.error}
        onErrorClose={(e) => setError(null)}
      />
    </>
  );

};

const mapStateToProps = (state: IReduxState): IConnectProps => {
  const auth = state.login.auth ? state.login.auth : null;
  const query = state.router.location.query ? state.router.location.query : null;
  return {
      query,
      auth,
      router: state.router,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(TwoFactorAuth);
